import { Injectable, EventEmitter, Output, NgZone } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Map, Feature, } from 'ol';
import { Extent } from 'ol/extent';
import * as proj from 'ol/proj';
import View, { ViewOptions } from 'ol/View';
import { format } from 'ol/coordinate';
// import Feature from 'ol';
// import Feature from 'ol/Feature';
import { BaseEngine, MapEngineOptions, EngineType, WGisToolInterface, WGisToolOption, WGisServiceInterface } from './wgis.utils';
import { WGisOsmEngine } from './wgis.osmengine';
import { WGisVectorEngine } from './wgis.vectorengine';
import { WGisWmsEngine } from './wgis.wmsengine';
import { WGisOfflineEngine } from './wgis.offlineengine';
// import { WGisVectorEngine } from './wgis.vectorengine';
import Collection from 'ol/Collection';
import { Layer } from 'ol/layer';
import { WGisBaseTool, WGisToolContainer, ToolsNames } from './wgis.tool';
import { WGisToolMeasure } from './wgis.tool.measure';
import { WGisToolInfo } from './wgis.tool.info';
import { WGisToolDraw } from './wgis.tool.draw';
import { WGisToolModify } from './wgis.tool.modify';
import {
  WGisAlignement, WGisCfg, WGisDisplayMode,
  WGisFeatureInfo, CfgStyle,
  WGisFeatureInterface
} from './wgis.utils';
import VectorSource from 'ol/source/Vector';
import { Title } from '@angular/platform-browser';
import { WMAIApiService, GeolocationService, AppInformationService, ExpLocalStorage } from '../core/services';
import WKT from 'ol/format/WKT';
import { WGisTooltip } from './wgis.ui.tooltip';
import { Geometry, Point, Circle } from 'ol/geom';
import Polygon from 'ol/geom/Polygon';
import LineString from 'ol/geom/LineString';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Angulartics2 } from 'angulartics2';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Style, Fill, Stroke, Circle as CircleStyle, Icon } from 'ol/style';
import { ImageModal, ConfirmModal, SimpleModal, ConfirmFormModal, } from 'src/app/core/templates';
import { Control, defaults as defaultControls, ScaleLine } from 'ol/control';
import Overlay from 'ol/Overlay';
// import {}  from
import {
  SchedaIntense,
  Ost,
  Experience,
  Item,
  GisQureyResult,
  AppStatus,
} from '../core/models';
// import { EsperienzeListConfig, Experience, Language,
// Alert, Attachment, Stop, Item, Ost } from '../models';
import { NULL_EXPR } from '@angular/compiler/src/output/output_ast';
import { SuiModalService, ModalSize } from 'ng2-semantic-ui';
// import { transformWithOptions } from 'ol/format/Feature';
import { TileJSON } from 'ol/source';
import { Subscription } from 'rxjs';
import { FeatureClass } from 'ol/Feature';
import { WGisFeature } from './wgis.feature';
import OverlayPositioning from 'ol/OverlayPositioning';
import IconAnchorUnits from 'ol/style/IconAnchorUnits';
import VectorLayer from 'ol/layer/Vector';
import IconOrigin from 'ol/style/IconOrigin';
import { WGisCacheEngine } from './wgis.offlinecache';
import GeometryType from 'ol/geom/GeometryType';
import { MapCacheData } from '../core/models/mapcache';
import { ModalService } from '../core/services/modal.service';
declare var window;

interface ToolsContainerMap {
  tl?: WGisToolContainer;
  bl?: WGisToolContainer;
  ml?: WGisToolContainer;
  tr?: WGisToolContainer;
  br?: WGisToolContainer;
  mr?: WGisToolContainer;
}
enum WmaiFeaturename {
  SCHEDA = 'scheda',
  OST = 'ost',
  ESPERIENZA = 'expirience',
  ITEM = 'item',
}


@Injectable({
  providedIn: 'root'
})
export class WgisService implements WGisServiceInterface {

  private useMbTiles = true;
  public pMap: Promise<Map>;
  public engines: BaseEngine[] = [];
  public config: WGisCfg = undefined;
  public map: Map = undefined;
  public pHaveConfig: Promise<WGisCfg>;
  public pHaveMaster: Promise<BaseEngine>;
  public pHaveDiv: Promise<string>;
  public pHavePopup: Promise<string>;

  // private divname: string;
  private olLayers: Collection<Layer> = undefined;
  private count = 0;
  private mode = 0;
  private mapvisible: boolean;
  private mapmode: WGisDisplayMode = WGisDisplayMode.Invisible;
  private waitingcounter = 0;
  private toolscontainer: ToolsContainerMap;
  private tools: WGisBaseTool[];
  private toolsmap: { [toolname: string]: WGisBaseTool };
  private selection: WGisVectorEngine;
  private currentObjLayer: WGisVectorEngine;
  private siResults: SchedaIntense[] = [];
  private ostResults: Ost[] = [];
  private expResults: Experience[] = [];
  // private httpClient: HttpClient;
  // private apiService: ApiService;
  // @Output() wgisToggle = new EventEmitter<boolean>();
  private tooltips: WGisTooltip[] = [];
  private visitedOst: string[];
  private subscribePosition: Subscription;
  private subscribeTrackMe: Subscription;
  private currentPosition: Position;
  private ifollowyou = false;
  private pauseFollowMe = false;
  private tt: WGisTooltip;
  private iconFeature = new Feature();
  private accuracyFeature = new Feature();
  private cachemanager: WGisCacheEngine;


  @Output() wgisClearSelection = new EventEmitter<boolean>();
  @Output() wgisStartInteraction = new EventEmitter<WGisToolInterface>();
  @Output() wgisVisible = new EventEmitter<WGisDisplayMode>();
  @Output() wgisRefresh = new EventEmitter<boolean>();
  @Output() wgisWaiting = new EventEmitter<boolean>();
  @Output() wgisZoomAt = new EventEmitter<number[]>();
  @Output() wgisCenter = new EventEmitter<number[]>();
  @Output() wgisZoomLevel = new EventEmitter<number>();
  @Output() wgisEngine = new EventEmitter<BaseEngine>();
  @Output() wgisBaseOn = new EventEmitter<BaseEngine>();
  @Output() wgisSISelected = new EventEmitter<boolean>();
  @Output() wgisViewChage = new EventEmitter<{ xmin: number, ymin: number, xmax: number, ymax: number }>();
  @Output() wgisEngines = new EventEmitter<BaseEngine[]>();

  public setDiv: (div: string) => void = undefined;
  public setErrorDiv: (err: Error) => void = undefined;

  public setMaster: (engine: BaseEngine) => void = undefined;
  public setErrorMaster: (err: Error) => void = undefined;

  public setPopup: (div: string) => void = undefined;
  public setErrorPopup: (err: Error) => void = undefined;


  public isSmallScreen = false;
  private cleartool: string;
  private closetool: string;
  private distancetool: string;
  private drawpointtool: string;
  private drawlinetool: string;
  private drawareatool: string;
  private areatool: string;
  private resettool: string;
  private findme: string;
  private followme: string;
  private imhere: string;

  private tooltip: string;
  private currentData: {
    currExpirience: Experience,
    currItem: Item,
    currOst: Ost,
    featCurrExpirience: WGisFeatureInterface,
    featCurrItem: WGisFeatureInterface
    featCurrOst: WGisFeatureInterface
  };

  private defaultstyle: Style;
  private styles: { feature: string, style: Style }[];


  constructor(
    private httpClient: HttpClient,
    private sin2wrapper: WMAIApiService,
    // private appinfo: AppInformationService,
    private router: Router,
    private translateService: TranslateService,
    private angulartics2: Angulartics2,
    private breakpointObserver: BreakpointObserver,
    private geoservice: GeolocationService,
    private modalService: SuiModalService,
    private appinfoService: AppInformationService,
    private locSotreSrv: ExpLocalStorage,
    private ngZone: NgZone,
    private modal: ModalService
  ) {
    this.cachemanager = null;
    this.map = null;
    this.currentData = {
      currExpirience: null,
      currItem: null,
      currOst: null,
      featCurrExpirience: null,
      featCurrItem: null,
      featCurrOst: null,
    };
    this.isSmallScreen = window.innerWidth <= 768;
    // this.isSmallScreen = breakpointObserver.isMatched('(max-width: 768px)');
    this.toolscontainer = {};
    this.mapvisible = false;
    this.olLayers = new Collection();
    this.translateService.use(localStorage.getItem('locale') || 'it');
    this.translateService.get(['wgis.service.tools.area', 'wgis.service.tools.clear', 'wgis.service.tools.closemap',
      'wgis.service.tools.distance', 'wgis.service.tools.reset', 'wgis.ui.tooltip.mytooltipelement.title'
    ]).subscribe(translations => {
      this.areatool = translations['wgis.service.tools.area'];
      this.cleartool = translations['wgis.service.tools.clear'];
      this.closetool = translations['wgis.service.tools.closemap'];
      this.distancetool = translations['wgis.service.tools.distance'];
      this.drawpointtool = translations['wgis.service.tools.drawpoint'];
      this.drawlinetool = translations['wgis.service.tools.drawpoint'];
      this.drawareatool = translations['wgis.service.tools.drawpoint'];
      this.resettool = translations['wgis.ui.tooltip.mytooltipelement.title'];
      this.findme = translations['wgis.service.tools.findme'];
      this.followme = translations['wgis.service.tools.followme'];
      this.imhere = translations['wgis.ui.tooltip.imhere'];
    });

    this.geoservice.changeCurrentPosition.subscribe((data) => {
      // console.log(data);
      this.currentPosition = data;
    });

    // promise per configurazione
    this.pHaveConfig = new Promise<WGisCfg>((resolve, reject) => {
      if (appinfoService.getCurrentConnectionStatus()) {
        this.httpClient.get(`${environment.api_url}/wgis`, { params: { responseType: 'json' }, })
          .subscribe((resp: any) => {
            if (resp.data) {
              this.config = resp.data;
              this.locSotreSrv.setWgisCfg(this.config);
              resolve(this.config);
            } else { reject(resp.status); }
          });
      } else {
        this.config = this.locSotreSrv.getWgisCfg();
        resolve(this.config);
      }
    });

    // promise per div target della mappa
    this.pHaveDiv = new Promise<string>((resolve, reject) => {
      this.setDiv = resolve;
      this.setErrorDiv = reject;
    });

    // promise per layer master
    this.pHaveMaster = new Promise<BaseEngine>((resolve, reject) => {
      this.setMaster = resolve;
      this.setErrorMaster = reject;
    });

    // promise per div target del popup
    this.pHavePopup = new Promise<string>((resolve, reject) => {
      this.setPopup = resolve;
      this.setErrorPopup = reject;
    });

    // inizializza gli engine definiti nella configurazione
    this.pHaveConfig.then((cfg: WGisCfg) => {
      this.handleConfig(cfg);
    });

    // promise per mappa si risolve dopo Div e dopo Config
    this.pMap = new Promise<Map>((resolve, reject) => {
      Promise.all([
        this.pHaveDiv,
        this.pHaveConfig,
        // this.pHaveMaster,
      ]).then((values: any[]) => {
        const div: string = values[0];
        const cfg: WGisCfg = values[1];
        // const master: BaseEngine = values[1];
        const viewopt: ViewOptions = {};
        Object.keys(cfg.view).forEach((key: string, index: number) => {
          viewopt[key] = cfg.view[key];
        });

        this.map = new Map({
          layers: this.olLayers,
          target: div,
          view: new View(viewopt)
        });
        this.map.getView().on('change', () => {
          this.wgisViewChage.emit(this.getViewExtent());
        });

        resolve(this.map);
      });
    });

    // inizializza  tools dopo che la mappa e statac creata
    this.pMap.then((map: Map) => {
      this.toolsInit();
      this.infoInit();
    });

    // event listeners
    this.initListeners();

    // analitics
    this.initAnalitics();

  }

  /**
   * Inizializzazione dei Listmìners
   */
  private initListeners() {

    this.wgisVisible.subscribe((mode: WGisDisplayMode) => { this.mapmode = mode; });

    this.wgisZoomAt.subscribe((param: number[]) => { this.cmdZoomAt(param); });
    this.wgisCenter.subscribe((param: number[]) => { this.cmdCenter(param); });
    this.wgisZoomLevel.subscribe((param: number) => { this.cmdZoomLevel(param); });
    this.wgisRefresh.subscribe((param: boolean) => { this.cmdRefresh(param); });
    this.wgisEngine.subscribe((engine: BaseEngine, index: number) => { this.cmdEngine(engine, index); });

    this.appinfoService.changeDownloadMaps.subscribe((id: number) => {
      if (this.cachemanager !== null) {
        if(MapCacheData.get().length == 0){
          let index = this.engines.indexOf(this.cachemanager);
          this.engines.splice(index, 1);
          this.cachemanager = null;
          this.emitEngines();
        } else {
          this.cachemanager.mapsChanged();
        }
      } else {
        this.addOffLineEng();
        this.cachemanager.mapsChanged();
      }
    });
    this.sin2wrapper.selectedExperience.subscribe((currExpireience: Experience) => {
      this.currentData.currExpirience = currExpireience;
      if (this.currentData.featCurrExpirience) {
        this.currentObjLayer.removeFeatureFromSelection(this.currentData.featCurrExpirience);
      }
      this.currentData.featCurrExpirience = this.currentObjLayer.feature_factory(
        WGisVectorEngine.extract_fileds(currExpireience), currExpireience.geom);
    });

    this.sin2wrapper.selectedItem.subscribe((currItem: Item) => {
      this.currentData.currItem = currItem;
      this.currentData.featCurrItem = this.currentObjLayer.feature_factory(
        WGisVectorEngine.extract_fileds(currItem), currItem.geom);
    });

    this.sin2wrapper.selectedOst.subscribe((currOst: Ost) => {
      this.currentData.currOst = currOst;
      this.currentData.featCurrOst = this.currentObjLayer.feature_factory(
        WGisVectorEngine.extract_fileds(currOst), currOst.geom);
    });


    this.subscribePosition = this.geoservice.seeCurrentPosition.subscribe(position => {
      // console.log(position);
      this.currentPosition = position;
      this.seeFindMe();
    });

    this.appinfoService.onlineStatus.subscribe((online) => {
      if (this.appinfoService.iAmMobile()) {
        // if (this.engines.filter(eng => eng.type === EngineType.OFFLINEXYZ).length === 0) {
        //   this.addOffLineEng();
        // }
        this.offlineEventHandler(online);
      }
    });
    this.appinfoService.changeCurrentStatus.subscribe((status: AppStatus) => {
      if (status === AppStatus.None) {
        if (this.ifollowyou) {
          this.unsubscribeToFollow();
          this.ifollowyou = false;
        }
      }
    });

  }

  /**
   * inizializzazione dei gestori per analitcs
   */
  private initAnalitics() {
    this.angulartics2.eventTrack.next({
      action: 'showExperiences',
      properties: { label: 'WgisServiceShowExperiences' },
    });

    this.angulartics2.eventTrack.next({
      action: 'showSchedaIntense',
      properties: { label: 'WgisServiceShowSchedaIntense' },
    });

    this.angulartics2.eventTrack.next({
      action: 'showOst',
      properties: { label: 'WgisServiceShowOst' },
    });

    this.angulartics2.eventTrack.next({
      action: 'cmdToggleMap',
      properties: { label: 'WgisServiceCmdToggleMap' },
    });

    this.angulartics2.eventTrack.next({
      action: 'cmdRefresh',
      properties: { label: 'WgisServiceCmdRefresh' },
    });

    this.angulartics2.eventTrack.next({
      action: 'cmdZoomAt',
      properties: { label: 'WgisServiceCmdZoomAt' },
    });

    this.angulartics2.eventTrack.next({
      action: 'cmdCenter',
      properties: { label: 'WgisServiceCmdCenter' },
    });

  }
  /**
   *  gestosce l'evento offline
   * @param online:boolean true se on linefalse altrimenti
   */
  private offlineEventHandler(online: boolean) {
    for (let i = 0, j = this.engines.length; i < j; i++) {
      const eng: BaseEngine = this.engines[i];
      if ((eng.type === EngineType.OFFLINEXYZ) || (eng.type === EngineType.MBTILECACHE)) {
        if (online) {
          eng.turn(false);
          eng.hide();
        } else {
          eng.turn(true);
          eng.show();
        }
      } else if ((eng.type === EngineType.OSM) || (eng.type === EngineType.WMS)) {
        if (online) {
          eng.turn(true);
          eng.show();
        } else {
          eng.turn(false);
          eng.hide();
        }
      }
    }
  }

  private setStyles(styledefs: CfgStyle[]) {
    this.styles = [];
    this.defaultstyle = null;

    for (let i = 0, j = styledefs.length; i < j; i++) {
      const def = styledefs[i];
      let opt: any = {};

      if (def.fill) {
        opt.fill = new Fill({ color: def.fill.color });
      }
      if (def.stroke) {
        opt.stroke = new Stroke({ color: def.stroke.color, width: def.stroke.width });
      }
      if (def.circle) {
        opt.image = new CircleStyle({
          stroke: new Stroke({ color: def.circle.stroke }),
          fill: new Stroke({ color: def.circle.fill }),
          radius: def.circle.radius
        });
      }
      const sty = new Style(opt);
      this.styles.push({ feature: def.feature, style: sty });
      if (def.feature === 'default') {
        this.defaultstyle = sty;
      }
    }
    // se nn definito default lo definisco qui
    if (this.defaultstyle === null) {
      this.defaultstyle = new Style({
        fill: new Fill({ color: '#0066cc', }),
        stroke: new Stroke({ color: '#0066cc', width: 3, }),
        image: new CircleStyle({
          radius: 5,
          stroke: new Stroke({ color: '#0066cc' }),
          fill: new Fill({ color: '#0066cc' })
        })
      });
    }
  }

  private addOffLineEng() {
    // gestore delle cache se app cordova
    if (this.useMbTiles) {
      if (this.appinfoService.iAmMobile() && MapCacheData.get().length > 0 && !this.cachemanager) {
        const opt: MapEngineOptions = {
          isBase: true, noDispName: [], isMaster: false, isSelection: false, isEdit: false,
          isOn: false, selectable: false, editable: false, zorder: 0,
          name: 'OFFLINE MAP', title: 'OFFLINE MAP', projection: 'EPSG:3857',
          type: EngineType.MBTILECACHE,
          icon: 'fa-wifi',
        };
        this.cachemanager = new WGisCacheEngine(opt, this);
        this.engines.push(this.cachemanager);
        this.emitEngines();
      } /* Solo per test
      else {
          const opt: MapEngineOptions = {
            isBase: true, noDispName: [], isMaster: false, isSelection: false, isEdit: false,
            isOn: false, selectable: false, editable: false, zorder: 0,
            name: 'cache', title: 'cache', projection: 'EPSG:3857',
            url:'http://localhost:8000/services/sardinia13/tiles/{z}/{x}/{y}.pbf',
            type: EngineType.MBTILECACHE,
            icon: 'fa-wifi',
          };
          this.cachemanager = new WGisCacheEngine(opt, this);
          this.engines.push(this.cachemanager);
      }*/
    } else {
      if (this.appinfoService.iAmMobile()) {
        // offline tms cache
        this.engines.push(this.engine_factory({
          type: EngineType.OFFLINEXYZ,
          isBase: true,
          isMaster: false,
          isSelection: false,
          isEdit: false,
          isOn: false,
          selectable: false,
          editable: false,
          zorder: 0,
          icon: 'fa-wifi',
          name: 'wmai_osm',
          title: 'wmai_osm',
          noDispName: [],
          extension: 'png',
          size: [256, 256],
          bbox: [878839, 4668558, 1111209, 5058694],
          projection: 'EPSG:3857',
          resolutions: [55.1, 26.4583862506, 13.2291931253, 5.2916772501],
          // 2.6458386251, 1.9843789688, 1.3229193125, 0.529167725, 0.2645838625],
        }, 0));
        this.emitEngines();
      }

    }
  }

  private handleConfig(cfg: WGisCfg) {
    this.setStyles(cfg.styles ? cfg.styles : []);

    this.addOffLineEng();

    cfg.engine.forEach((eng: MapEngineOptions, ind: number) => {
      this.engines.push(this.engine_factory(eng, ind));
    });
    this.selection = new WGisVectorEngine({
      type: EngineType.VECTOR,
      isBase: false,
      isMaster: false,
      isEdit: false,
      isOn: true,
      isSelection: true,
      noDispName: [],
      title: '',
      name: 'selection____',
      selectable: true,
      editable: true,
      zorder: cfg.engine.length,
    }, this);
    this.selection.setDefaultStyle(this.getStyle('selection'));
    this.engines.push(this.selection as BaseEngine);
    //  layer for display current objects
    this.currentObjLayer = new WGisVectorEngine({
      type: EngineType.VECTOR,
      isBase: false,
      isMaster: false,
      isEdit: false,
      isOn: true,
      isSelection: true,
      noDispName: [],
      title: '',
      name: 'current____',
      selectable: true,
      editable: true,
      zorder: cfg.engine.length,
    }, this);
    this.engines.push(this.currentObjLayer);
    this.selection.setDefaultStyle(this.getStyle('current'));
    this.offlineEventHandler(this.appinfoService.getCurrentConnectionStatus());
    this.emitEngines();
  }

  /**
   * inizializza le la barre degli strumenti
   */
  private toolsInit() {
    this.toolsmap = {};
    const all = WGisAlignement.topRight;

    // const tc = new WGisToolContainer({ wgisservice: this, alignment: WGisAlignement.horizzontal, top: true, right: true });
    let th: WGisBaseTool = new WGisBaseTool({
      wgisservice: this,
      active: false,
      title: this.closetool,
      icon: 'fa-times',
      trigger: () => { this.wgisVisible.emit(WGisDisplayMode.Invisible); this.mapvisible = false; },
    });
    this.addTool({ alignment: all, tool: th });
    this.toolsmap[ToolsNames.CLOSE] = th;

    th = new WGisToolInfo({
      wgisservice: this,
      active: true,
      icon: 'fa-info-circle',
      title: 'Info',
    }, 2, 200);
    this.addTool({ alignment: all, tool: th });
    this.toolsmap[ToolsNames.INFO] = th;

    th = new WGisBaseTool({
      wgisservice: this,
      active: true,
      icon: 'fa-scroll',
      title: 'Map Legend',
      trigger: () => {
        let map_legend = this.appinfoService.getMapLegend();
        if(map_legend){
          this.modal.openModal("maps.legend", map_legend.val);
        }
      },
    });
    this.addTool({ alignment: all, tool: th });
    this.toolsmap[ToolsNames.MAP_LEGEND] = th;

    // th = new WGisBaseTool({
    //   wgisservice: this,
    //   active: true,
    //   trigger: () => { this.wgisStartInteraction.emit(null); },
    //   icon: 'fa-hand-paper',
    //   title: this.resettool,
    // });
    // this.addTool({ alignment: all, tool: th });
    // this.toolsmap[ToolsNames.RESETINTERACTION] = th;

    // th = new WGisBaseTool({
    //   wgisservice: this,
    //   active: false,
    //   trigger: () => { this.clearSelection(); },
    //   icon: 'fa-eraser',
    //   title: this.cleartool,
    // });
    // this.addTool({ alignment: all, tool: th });
    // this.toolsmap[ToolsNames.CLEARSELECTION] = th;

    th = new WGisBaseTool({
      wgisservice: this,
      active: false,
      trigger: () => { this.findMe(); },
      icon: 'fas fa-map-marker-alt',
      title: this.findme,
    });
    this.addTool({ alignment: all, tool: th });
    this.toolsmap[ToolsNames.FINDME] = th;

    th = new WGisBaseTool({
      wgisservice: this,
      active: false,
      trigger: () => { this.followMe(); },
      icon: 'fas fa-location-arrow',
      title: this.followme,
    });
    this.addTool({ alignment: all, tool: th });
    this.toolsmap[ToolsNames.FOLLOWME] = th;

    /*
    th = new WGisToolDraw({
      wgisservice: this,
      active: false,
      icon: 'fa-eye-dropper',// icon: 'fa-crosshairs',
      title: this.drawpointtool,
    }, 'Point');
    this.addTool({ alignment: WGisAlignement.midRight, tool: th });
    this.toolsmap[ToolsNames.DRAWPOINT] = th;

    th = new WGisToolDraw({
      wgisservice: this,
      active: false,
      icon: 'fa-pencil-alt', // icon: 'fa-wave-square',
      title: this.drawlinetool,
    }, 'Line');
    this.addTool({ alignment: WGisAlignement.midRight, tool: th, });
    this.toolsmap[ToolsNames.DRAWLINE] = th;

    th = new WGisToolDraw({
      wgisservice: this,
      active: false,
      icon: 'fa-paint-roller',  // icon: 'fa-draw-polygon',
      title: this.drawareatool,
    }, 'Polygon');
    this.addTool({ alignment: WGisAlignement.midRight, tool: th });
    this.toolsmap[ToolsNames.DRAWPOLYGON] = th;

    th = new WGisToolModify({
      wgisservice: this,
      active: false,
    });
    this.addTool({ alignment: WGisAlignement.midRight, tool: th });
    this.toolsmap[ToolsNames.MODIFY] = th;
    */
  }

  infoInit() {
    var position_layer = new Overlay({
      element: document.getElementById('my-position'),
      className: 'wgis-coordinate-tip ol-unselectable'
    });

    this.map.addOverlay(position_layer);
    var info = document.getElementById('my-position');
    this.map.on('moveend', () => {
      var view = this.map.getView();
      var center = view.getCenter();
      var coord = proj.toLonLat(center, 'EPSG:3857');
      var template = '{y} | {x}';
      var out = format(coord, template, 5);
      info.innerHTML = out;
    });

    var control = new ScaleLine();
    this.map.addControl(control);

    var timeuot;

    this.map.on('pointerdrag', () => {

      if (this.pauseFollowMe) {
        clearTimeout(timeuot);
        timeuot = setTimeout(() => {
          this.pauseFollowMe = false;
        }, 5000);
      } else {
        if (this.ifollowyou) {
          this.pauseFollowMe = true;

          timeuot = setTimeout(() => {
            this.pauseFollowMe = false;
          }, 5000);
        }
      }
    });

    var iconStyle = new Style({
      image: new CircleStyle({
        radius: 9,
        fill: new Fill({
          color: '#3399CC'
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 3
        })
      })
    })
    this.iconFeature.setStyle(iconStyle);
    var vectorSource = new VectorSource({
      features: [this.iconFeature, this.accuracyFeature]
    });
    var vectorLayer = new VectorLayer({
      source: vectorSource,
      zIndex: 2
    });
    this.map.addLayer(vectorLayer);
  }

  /** abilità l'editing */
  private enableEditing(flag: boolean) {
    /* disattivato editing
    if (flag) {
      this.toolsmap[ToolsNames.MODIFY].deactivate();
      this.toolsmap[ToolsNames.DRAWPOLYGON].deactivate();
      this.toolsmap[ToolsNames.DRAWLINE].deactivate();
      this.toolsmap[ToolsNames.DRAWPOLYGON].deactivate();
      this.toolsmap[ToolsNames.DRAWPOLYGON].hide();
      this.toolsmap[ToolsNames.DRAWLINE].hide();
      this.toolsmap[ToolsNames.DRAWPOLYGON].hide();
    } else {
      this.toolsmap[ToolsNames.DRAWPOLYGON].show();
      this.toolsmap[ToolsNames.DRAWLINE].show();
      this.toolsmap[ToolsNames.DRAWPOLYGON].show();
      this.toolsmap[ToolsNames.MODIFY].activate();
    }
    */
  }

  /**
   * restitusce lo stile per il nome e se non lo trova restitusce lo stile di default
   * @param name nome della feature o nome dello style
   */
  getStyle(name: string): Style {
    for (let i = 0, j = this.styles.length; i < j; i++) {
      if (this.styles[i].feature === name) {
        return this.styles[i].style;
      }
    }
    return this.defaultstyle;
  }

  getMapMode(): WGisDisplayMode { return this.mapmode; }

  getVectorSource(name: string = 'selection'): VectorSource {
    if (name === 'selection') {
      return this.selection.source;
    } else if (name === 'edit') {
      return this.currentObjLayer.source;
    } else {
      return this.selection.source;
    }
  }

  addTool({ alignment, tool }: { alignment: WGisAlignement; tool: WGisToolInterface; }): void {
    switch (alignment) {
      case WGisAlignement.topLeft: {
        if (this.toolscontainer.tl === undefined) {
          this.toolscontainer.tl = new WGisToolContainer({ wgisservice: this, alignment: WGisAlignement.horizontalTopLeft });
        }
        this.toolscontainer.tl.addTool(tool);
        break;
      }
      case WGisAlignement.bottomLeft: {
        if (this.toolscontainer.bl === undefined) {
          this.toolscontainer.bl = new WGisToolContainer({ wgisservice: this, alignment: WGisAlignement.horizontalBottomLeft });
        }
        this.toolscontainer.bl.addTool(tool);
        break;
      }
      case WGisAlignement.midLeft: {
        if (this.toolscontainer.ml === undefined) {
          this.toolscontainer.ml = new WGisToolContainer({ wgisservice: this, alignment: WGisAlignement.verticalMidLeft });
        }
        this.toolscontainer.ml.addTool(tool);
        break;
      }
      case WGisAlignement.topRight: {
        if (this.toolscontainer.tr === undefined) {
          this.toolscontainer.tr = new WGisToolContainer({ wgisservice: this, alignment: WGisAlignement.horizontalTopRight });
        }
        this.toolscontainer.tr.addTool(tool);
        break;
      }
      case WGisAlignement.midRight: {
        if (this.toolscontainer.mr === undefined) {
          this.toolscontainer.mr = new WGisToolContainer({ wgisservice: this, alignment: WGisAlignement.verticalMidRight });
        }
        this.toolscontainer.mr.addTool(tool);
        break;
      }
      case WGisAlignement.bottomRight: {
        if (this.toolscontainer.br === undefined) {
          this.toolscontainer.br = new WGisToolContainer({ wgisservice: this, alignment: WGisAlignement.horizontalBottomRight });
        }
        this.toolscontainer.br.addTool(tool);
        break;
      }
      default: {
        if (this.toolscontainer.tl === undefined) {
          this.toolscontainer.tl = new WGisToolContainer({ wgisservice: this, alignment: WGisAlignement.horizontalTopLeft });
        }
        this.toolscontainer.tl.addTool(tool);
        break;
      }
    }
  }
  /********************************** * ESPERIENZE */

  /**
   *
   * @param results
   */
  showExperiences(results: Experience[]) {
    results.forEach(exp => {
      this.showEsperienzaByObj(exp, false);
    });
    this.cmdZoomLevel(7);
  }

  showEsperienzaById(id: number, locale: string) {
    if (id === null) {
      return;
    }
    this.sin2wrapper.querySingleEsperienza(id, locale).subscribe((esperienza) => {
      this.showEsperienzaByObj(esperienza['data'][0]);
    });
  }

  showEsperienzaByObj(esperienza: Experience, zoom: boolean = true): void {
    if (esperienza === null) {
      return;
    }

    if (!esperienza.geom) {
      return;
    }

    let vector: WGisVectorEngine;

    // console.log(`show esperienza ${esperienza.id} ${esperienza.title} stauts ${esperienza.status} `);
    if (esperienza.status === 'public') {
      vector = this.selection;
    } else {
      vector = this.currentObjLayer;
    }

    const wkt: string = esperienza.geom;
    try {
      const feature = vector.selectByAny(wkt, esperienza);
      feature.setWgisInfo({
        className: 'Expirence',
        layerName: vector.name,
        layerkey: 'id',
        featId: WmaiFeaturename.ESPERIENZA,
      });
      this.addTooltiptoFeature(
        feature,
        esperienza.title,
        `<a href="#/esperienza/${esperienza.id}" style="color: white"><b>${esperienza.id}</b>: ${esperienza.title}</a>`
      );
      if (zoom) {
        const geom = feature.getGeometry();
        if (geom) {
          this.cmdZoomAt(geom.getExtent());
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  /********************************** * SCHEDE */
  /**
   * Seleziona una scheda dalla scheda
   * @param scheda : SchedqIntense  la scheda da selezionare
   */
  showSchedaIntenseByObj(scheda: SchedaIntense, zoom: boolean = true) {
    const wkt: string = scheda.geom;
    if ((wkt === undefined) || (wkt === null) || wkt === '') {
      return;
    }
    // console.log(`show scheda ${scheda.id} title: ${scheda.titolo}`);

    try {
      const feature = this.selection.selectByAny(wkt, scheda);
      feature.setWgisInfo({
        className: 'SchedaIntense',
        layerName: this.selection.name,
        layerkey: 'id',
        featId: WmaiFeaturename.SCHEDA,
      });
      this.addTooltiptoFeature(feature, scheda.titolo,
        `<a href="#/scheda/${scheda.id}" style="color: white"><b>${scheda.id}</b>: ${scheda.titolo}</a>`);
      if (zoom) {
        const geom = feature.getGeometry();
        if (geom) {
          this.cmdZoomAt(geom.getExtent());
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * seleziona una scheda da id
   * @param id  id della scheda da caricares
   */
  showSchedaIntenseById(id: number) {
    if (id == null) {
      return;
    }
    this.sin2wrapper.querySingleSchedaIntense(id, this.translateService.getDefaultLang()).subscribe((schedaintense) => {
      this.showSchedaIntenseByObj(schedaintense, false);
    });
  }

  showSchedeIntense(results: SchedaIntense[]) {
    results.forEach(si => {
      this.showSchedaIntenseByObj(si, false);
      // this.showSchedaIntenseById(si.id);
      si.selected = false;
      this.siResults.push(si);
    });
    this.cmdZoomLevel(7);
  }

  zoomOnSchedaIntense(idscheda: number) {
    let geom: Geometry;
    let fid: string | number;
    // console.log(`zoom scheda ${idscheda} `);

    this.selection.source.forEachFeature((f: WGisFeatureInterface) => {
      if (f.getProperties().id === idscheda) {
        geom = f.getGeometry();
        fid = f.getId();
        this.cmdZoomAt(geom.getExtent());
      }
    });
    for (let i = 0, j = this.tooltips.length; i < j; i++) {
      const tooltip = this.tooltips[i];
      if (tooltip.getFeature().getId() === fid) {
        // tooltip.text(`<a href="#/scheda/${idscheda}" style="color: white"><b>${idscheda}</b>: ${data.name}</a>`);
        if (geom instanceof Polygon) {
          tooltip.setPosition(geom.getInteriorPoint().getCoordinates());
        } else if (geom instanceof LineString) {
          tooltip.setPosition(geom.getLastCoordinate());
          tooltip.setSelected(true);
        } else {
          tooltip.setPosition(geom.getExtent());
        }
        // tooltip.hide();
      } else {
        tooltip.setSelected(false);
      }
    }
  }

  zoomOnItem(iditem: number) {
    let geom: Geometry;
    let fid: string | number;
    // console.log(`zoom item ${iditem} `);
    let found = false;
    this.selection.source.forEachFeature((f: WGisFeatureInterface) => {
      if (f.getProperties().id === iditem) {
        geom = f.getGeometry();
        fid = f.getId();
        this.cmdZoomAt(geom.getExtent());
        found = true;
      }
    });

    /* disabilitato editing gli item sono sempre in selection
    if (! found){
      this.currentObjLayer.source.forEachFeature((f: WGisFeatureInterface) => {
        if (f.getProperties().id === iditem) {
          geom = f.getGeometry();
          fid = f.getId();
          this.cmdZoomAt(geom.getExtent());
        }
      });
    }
    */

    for (let i = 0, j = this.tooltips.length; i < j; i++) {
      const tooltip = this.tooltips[i];
      if (tooltip.getFeature().getId() === fid) {
        // tooltip.text(`<a href="#/scheda/${idscheda}" style="color: white"><b>${idscheda}</b>: ${data.name}</a>`);
        if (geom instanceof Polygon) {
          tooltip.setPosition(geom.getInteriorPoint().getCoordinates());
        } else if (geom instanceof LineString) {
          tooltip.setPosition(geom.getLastCoordinate());
          tooltip.setSelected(true);
        } else {
          tooltip.setPosition(geom.getExtent());
        }
        // tooltip.hide();
      } else {
        tooltip.setSelected(false);
      }
    }
  }

  showItems(items: Item[]): void {
    for (let i = 0, j = 0; i < j; i++) {
      const item = items[i];
      this.showItemByObj(item, false);
    }
  }

  showItemByObj(item: Item, zoom: boolean = true): void {
    // console.log('showItemByObj _____' + item);
    if (item === null) {
      return;
    }
    let vector: WGisVectorEngine;
    vector = this.selection;
    /*  disabilitato editing
     if (item.sysdefined || (item.status === 'private')) {
       // non editable
       vector = this.selection;
      } else {
        vector = this.currentObjLayer;
      }
    */
    const wkt: string = item.geom;
    try {
      const feature = this.selection.selectByAny(wkt, item);
      feature.setWgisInfo({
        className: 'Item',
        layerName: vector.name,
        layerkey: 'id',
        featId: WmaiFeaturename.ITEM,
      });
      this.addTooltiptoFeature(feature, item.title,
        `<b>${item.id}</b>: ${item.title}</a>`);
      if (zoom) {
        const geom = feature.getGeometry();
        const type = feature.getGeometry().getType();
        // console.log(type);
        if (geom) {
          if (type !== GeometryType.POINT) {
            this.cmdZoomAt(geom.getExtent());
          } else {
            this.cmdZoomLevel(16);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
    return;
  }

  /********************************** * OST */
  showOsts(results: Ost[]) {
    results.forEach(ost => {
      this.showOstByObj(ost, false);
    });
    this.cmdZoomLevel(7);
  }

  showOstByObj(ost: Ost, zoom: boolean = true) {
    const wkt: string = ost.geom;
    if ((wkt === undefined) || (wkt === null) || wkt === '') {
      return;
    }
    // console.log(`show ost ${ost.id} title: ${ost.titolo}`);

    try {
      const feature = this.selection.selectByAny(wkt, ost);
      feature.setWgisInfo({
        className: 'Ost',
        layerName: this.selection.name,
        layerkey: 'id',
        featId: WmaiFeaturename.OST,
      });
      this.addTooltiptoFeature(feature, ost.titolo,
        `<a href="#/scheda/${ost.id}" style="color: white"><b>${ost.id}</b>: ${ost.titolo}</a>`);
      if (zoom) {
        const geom = feature.getGeometry();
        const type = feature.getGeometry().getType();
        if (geom) {
          if (type !== 'Point') {
            this.cmdZoomAt(geom.getExtent());
          } else {
            this.cmdZoomLevel(16);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  zoomOnOst(idost: number) {
    let geom: Geometry;
    let fid: string | number;
    // console.log(`zoom ost ${idost} `);

    this.selection.source.forEachFeature((f: WGisFeatureInterface) => {
      if (f.getProperties().id === idost) {
        geom = f.getGeometry();
        fid = f.getId();
        this.cmdZoomAt(geom.getExtent());
      }
    });
    for (let i = 0, j = this.tooltips.length; i < j; i++) {
      const tooltip = this.tooltips[i];
      if (tooltip.getFeature().getId() === fid) {
        if (geom instanceof Polygon) {
          tooltip.setPosition(geom.getInteriorPoint().getCoordinates());
        } else if (geom instanceof LineString) {
          tooltip.setPosition(geom.getLastCoordinate());
          tooltip.setSelected(true);
        } else {
          tooltip.setPosition(geom.getExtent());
        }
        // tooltip.hide();
      } else {
        tooltip.setSelected(false);
      }
    }
  }

  /**
   *
   * @param feature
   * @param text
   */
  private addTooltiptoFeature(feature: WGisFeatureInterface, transstring: string, text: string) {
    const tt = new WGisTooltip({
      map: this.map,
      wgisservice: this,
      initial: 'tooltip-measure',
      translation: transstring,
    });
    const fid = feature.getId();

    tt.text(text);
    tt.setFeature(feature);
    const geom: Geometry = feature.getGeometry();
    this.cmdZoomAt(geom.getExtent());
    if (geom instanceof Polygon) {
      tt.setPosition(geom.getInteriorPoint().getCoordinates());
    } else if (geom instanceof LineString) {
      tt.setPosition(geom.getLastCoordinate());
    } else if (geom instanceof Point){
      tt.setPosition(geom.getFirstCoordinate());
    }
    tt.setSelected(true);
    this.tooltips.push(tt);
  }

  // create new engine
  engine_factory(def: MapEngineOptions, indice: number): BaseEngine {
    if (def.zorder === undefined) {
      def.zorder = indice;
    }

    switch (def.type) {
      case EngineType.OSM: {
        return new WGisOsmEngine(def, this);
      }
      case EngineType.VECTOR: {
        return new WGisVectorEngine(def, this);
      }
      case EngineType.WMS: {
        return new WGisWmsEngine(def, this);
      }
      case EngineType.OFFLINEXYZ: {
        return new WGisOfflineEngine(def, this);
      }
    }
    console.log(`Unknown Engine type ${def.type} -----------------------------`);
    return null;
  }

  /**
   * rierca degli engine per nome
   * @param name
   */
  getEngine(name: string): BaseEngine {
    for (let i = 0, j = this.engines.length; i < j; i++) {
      if (this.engines[i].name === name) {
        return this.engines[i];
      }
    }
    return null;
  }

  /**
   * restitusce il promo engine che è on
   */
  getOnEngine(): BaseEngine {
    for (let i = 0, j = this.engines.length; i < j; i++) {
      if (this.engines[i].isOn) {
        return this.engines[i];
      }
    }
    return null;
  }

  cmdToggleMap() {
    this.mapvisible = !(this.mapvisible);
    if (this.mapvisible) {
      if (this.isSmallScreen) {
        this.wgisVisible.emit(WGisDisplayMode.Full);
      } else {
        this.wgisVisible.emit(WGisDisplayMode.Right);
      }
    } else {
      this.wgisVisible.emit(WGisDisplayMode.Invisible);
    }
  }

  setMapInvisible() {
    this.wgisVisible.emit(WGisDisplayMode.Invisible);
    this.mapvisible = false;
  }

  setMapVisible(isSmallScreen: boolean) {
    this.mapvisible = true;
    if (isSmallScreen) {
      this.wgisVisible.emit(WGisDisplayMode.Full);
    } else {
      this.wgisVisible.emit(WGisDisplayMode.Right);
    }
  }

  getMapVisible() {
    return this.mapvisible;
  }

  // a new engine is ready to be added
  cmdEngine(engine: BaseEngine, index: number): void {
    this.olLayers.setAt(index, engine.getLayer());
  }

  // update size
  cmdRefresh(param: boolean): void {
    this.pMap.then((map: Map) => {
      map.updateSize();
    });
  }

  // zoom at extent
  cmdZoomAt(param: number[]): void {
    if (param.length === 4) {
      this.pMap.then((map: Map) => {
        map.getView().fit((param as Extent));
      });
    }
  }

  // Center view
  cmdCenter(param: number[]): void {
    if (param.length === 2) {
      this.pMap.then((map: Map) => {
        map.getView().setCenter(param);
      });
    }
  }

  // set zoom
  cmdZoomLevel(param: number): void {
    this.pMap.then((map: Map) => {
      map.getView().setZoom(param);
    });
  }

  addLayer(layer: Layer, zorder: number): void { this.olLayers.insertAt(zorder, layer); }

  sequence(): number { return this.count++; }

  stopWaiting() {
    this.waitingcounter--;
    if (this.waitingcounter <= 0) {
      this.waitingcounter = 0;
      this.wgisWaiting.emit(false);
    }
  }

  startWaiting() {
    this.waitingcounter++;
    if (this.waitingcounter > 0) {
      this.wgisWaiting.emit(true);
    }
  }

  saveSelection() {
    throw new Error('Not Implemmented');
  }

  clearSelection(): void {
    // console.log(`clear selection  si: ${this.siResults.length}, ost; ${this.ostResults.length}, tooltips: ${this.tooltips.length}`);
    // console.log(`clear selection  si: ${this.siResults.length}, exp:${this.expResults.length}, ost; ${this.ostResults.length}, tooltips: ${this.tooltips.length}`);
    this.siResults = [];
    this.ostResults = [];
    this.expResults = [];
    if (this.selection != undefined) {
      this.selection.clearSelection();
    }
    // this.tooltips.forEach((tooltip) => {
    //   tooltip.dispose();
    // });
    this.visitedOst = [];
    this.wgisClearSelection.emit(true);
  }

  findMe(): void {
    // console.log("findMe");
    this.geoservice.getPosition();
  }

  seeFindMe() {
    if (this.currentPosition != null) {
      var coords: number[] = [this.currentPosition.coords.longitude, this.currentPosition.coords.latitude];
      /// todo usare parametri in configurazioen
      var ll = proj.transform(coords, 'EPSG:4326', 'EPSG:3857');

      this.accuracyFeature.setGeometry(new Circle(ll, this.currentPosition.coords.accuracy));
      this.iconFeature.setGeometry(new Point(ll));
      this.cmdCenter(ll);

      if (this.appinfoService.iAmMobile()) {
        this.cmdZoomLevel(20);
      } else {
        this.cmdZoomLevel(15);
      }
    }
  }

  subscribeToFollow() {
    this.subscribeTrackMe = this.geoservice.changeCurrentPosition.subscribe(position => {
      // console.log("FollowMe");
      this.currentPosition = position;
      this.seeFollowMe();
    });
  }

  unsubscribeToFollow() {
    this.geoservice.stopTrackMe();
    if (this.subscribeTrackMe != null) {
      this.subscribeTrackMe.unsubscribe();
    }
  }

  seeFollowMe() {
    if (this.currentPosition != null) {
      const coords: number[] = [this.currentPosition.coords.longitude, this.currentPosition.coords.latitude];
      const ll = proj.transform(coords, 'EPSG:4326', 'EPSG:3857');
      this.accuracyFeature.setGeometry(new Circle(ll, this.currentPosition.coords.accuracy));
      this.iconFeature.setGeometry(new Point(ll));
      this.cmdCenter(ll);

      if (!this.pauseFollowMe) {
        if (this.appinfoService.iAmMobile()) {
          this.cmdZoomLevel(20);
        } else {
          this.cmdZoomLevel(15);
        }
      }
      this.findOstAt(ll);
    }
    // this.findOstAt(ll);
    // this.findOstAt(ll);
  }


  findOstAt(coordinate: number[]) {
    const dist = 20;
    const selsource = this.selection.source;
    const extent: Extent = [
      coordinate[0] - dist,
      coordinate[1] - dist,
      coordinate[0] + dist,
      coordinate[1] + dist,
    ];
    selsource.forEachFeatureInExtent(<Extent>extent, (fea: WGisFeature) => {
      if (fea.getWgisInfo().featId === WmaiFeaturename.OST) {
        const ostid = fea.getId();
        if (this.visitedOst.findIndex((val: string) => (val === ('' + ostid))) < 0) {
          this.visitedOst.push('' + ostid);
          let title = 'OST'; //this.translateService.instant('modal.ost.save.confirmcontent');
          let content = 'OST' + ' ' + fea.get('titolo'); //this.translateService.instant('modal.esperienza.save.confirmcontent');
          this.modalService.open(new SimpleModal(title, content, ModalSize.Tiny))
            .onApprove(() => { })
            .onDeny(() => '');
        }
      }
    });
  }

  followMe(): void {
    this.ifollowyou = !this.ifollowyou;
    if (this.ifollowyou) {
      if (this.appinfoService.iAmMobile()) {
        window.plugins.insomnia.keepAwake();
      }
      this.subscribeToFollow();
      this.geoservice.trackMe();
    } else {
      this.geoservice.stopTrackMe();
      if (this.appinfoService.iAmMobile()) {
        window.plugins.insomnia.allowSleepAgain();
      }
      this.unsubscribeToFollow();
    }
  }

  getWmaiApiService(): WMAIApiService { return this.sin2wrapper; }

  getSelection(): void { }

  /**
   * edit geometry imposta la geometria della feature attiva la comunica alla applicazione  e invoca la persistenza
   * @param geom {Geometry} la geometria come oggetto ol
   */
  editGeometry(geom: Geometry): void {
    // console.log("edit");
    // console.log(this.currentData.currItem);
    if (this.currentData.currItem) {
      let format = new WKT();
      let wkt = format.writeGeometry(geom, { dataProjection: 'EPSG:4326', featureProjection: this.map.getView().getProjection() });
      this.currentData.currItem.geom = wkt;
      if (this.currentData.featCurrItem) {
        this.currentData.featCurrItem.setGeometry(geom);
      } else {
        const item = this.currentData.currItem;
        this.currentData.featCurrItem = this.currentObjLayer.selectByAny(item.geom, item);
        this.currentData.featCurrItem.setWgisInfo({
          className: 'Item',
          layerName: this.currentObjLayer.name,
          layerkey: 'id',
          featId: 'item',
        });
        this.addTooltiptoFeature(this.currentData.featCurrItem,
          item.title,
          `<a href="#/item/${item.id}" style="color: white"><b>${item.id}</b>: ${item.title}</a>`
        );
      }


      // TODO INVOCARE PERSISTENZA!!!!!! SALVARE LE MODIFICHE
      this.sin2wrapper.updateItemGeometry(this.currentData.currItem.id, wkt).subscribe(response => {
        // console.log('save');
        let title: string = this.translateService.instant('modal.esperienza.save.title');
        let content: string = this.translateService.instant('modal.esperienza.save.confirmcontent');
        this.modalService
          .open(new SimpleModal(title, content, ModalSize.Tiny))
          .onApprove(() => {

          })
          .onDeny(() => "");
      });
    }
  }

  addFeatureToSelection(feature: WGisFeatureInterface) { this.selection.addFeatureToSelection(feature); }

  removeFeatureFromSelection(feature: WGisFeatureInterface) { this.selection.removeFeatureFromSelection(feature); }

  sendNewOst(ost: GisQureyResult) {
    // console.log("Sono in wgis e lancio evento del nuovo ost");
    this.appinfoService.changeNewOst(ost);
  }

  getConnectionStatus(): boolean {
    return this.appinfoService.getCurrentConnectionStatus();
  }

  getSelectionSource(): VectorSource {
    return this.selection.source;
  }

  getViewExtent(): { xmin: number, ymin: number, xmax: number, ymax: number } {
    const ext = this.map.getView().calculateExtent();
    return { xmin: ext[0], ymin: ext[1], xmax: ext[2], ymax: ext[3] };
  }
  // wrappers per servizio appingo/////
  device(): string {
    return this.appinfoService.getDeviceInfo();
  }
  iAmMobile(): boolean {
    return this.appinfoService.iAmMobile();
  }

  getIsSmallScreen(){
    return this.isSmallScreen;
  }

  removeCache(id: number){
    return this.cachemanager.removeCache(id);
  }

  getAppStatus(): AppStatus{
    return this.appinfoService.getCurrentAppStatus();
  }

  addControlByElement(element: HTMLElement){
    this.pMap.then((map: Map) => {
      var control = new Control({element: element});
      map.addControl(control);
    })
  }

  getEngines(){
    return this.engines;
  }

  emitEngines(){
    this.wgisEngines.next(this.engines);
  }
  
  redirectToInfo(element: GisQureyResult){
    if (this.getConnectionStatus()) {
      if(this.getIsSmallScreen()){
        this.cmdToggleMap();
      }
      this.ngZone.run(() => {
        this.router.navigate([`/${element.tipo}/${element.id}`])
      });
    } else {
      if(this.getIsSmallScreen()){
        this.cmdToggleMap();
      }
      this.ngZone.run(() => {
        this.router.navigate([`/downloaded/${element.tipo}/${element.id}`])
      });
    }
  }
}
